export default "__VITE_ASSET__BxFoOydJ__"